import React from "react";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  body,
  confirmText,
  cancelText,
  isLoading,
  confirmVariant = "danger",
}) => {
  const { t, i18n } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="team-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      dir={i18n.dir()}
      lang={i18n.language}
    >
      <div className="team-modal" style={{ maxWidth: "420px" }}>
        <div className="team-modal-body" style={{ padding: "32px 24px 24px" }}>
          <div className="team-confirm-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h3 className="team-confirm-title">{title}</h3>
          <p className="team-confirm-body">{body}</p>
          <div className="team-confirm-actions">
            <button
              type="button"
              className="team-btn team-btn-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelText || t("manageTeam.buttons.cancel")}
            </button>
            <button
              type="button"
              className={`team-btn ${confirmVariant === "danger" ? "team-btn-danger" : "team-btn-primary"}`}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="team-spinner" style={{ width: "16px", height: "16px", borderWidth: "2px" }} />
                  {confirmText}
                </>
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
